
const SET_CUSTAS_ATIVAS = 'SET_CUSTAS_ATIVAS'

export default {
  namespaced: true,
  state: {
    custasAtivas: [],
    papeisSelecionados: []
  },
  getters: {
    getCustasAtivas: (state) => state.custasAtivas,
  },
  mutations: {
    [SET_CUSTAS_ATIVAS] (state, data) {
      state.custasAtivas = data
    },
  },
  actions: {
    setCustasAtivas ({ commit }, data) {
      commit(SET_CUSTAS_ATIVAS, data)
    },
  }
}



